// Availability message on change variant
document.addEventListener('DOMContentLoaded', function () {
    const selectElement = document.querySelector('.options-selection__input-select-wrapper select');
    const inventoryMessages = document.querySelectorAll('.ctm_msg_wrp');

    // Run only if select exists and multiple messages are present
    if (selectElement && inventoryMessages.length > 1) {
        // Hide all messages initially
        inventoryMessages.forEach(msg => msg.style.display = 'none');

        // Function to show the matching message
        const showMatchingMessage = () => {
            const variantValue = selectElement.closest('.variant-selection').getAttribute('variant');
            console.log('Variant:', variantValue);

            inventoryMessages.forEach(msg => {
                msg.style.display = (msg.getAttribute('data-vid') === variantValue) ? 'flex' : 'none';
            });
        };

        // Initial message display on load
        showMatchingMessage();

        // Update on change
        selectElement.addEventListener('change', showMatchingMessage);
    } else {
        console.log('Either select element missing or not enough inventory messages.');
    }
});
